/**
 * Anewall Custom Checkout Intercept
 *
 * Intercepts the Checkout button click. If the cart contains any
 * custom-priced wallpaper items (_custom_price), it creates a
 * draft order via the Worker and redirects to that checkout.
 * If no custom-priced items, normal Shopify checkout proceeds.
 */
(function() {
  'use strict';

  var WORKER_URL = 'https://anewall-checkout.raspy-hat-3bb2.workers.dev';

  function hasCustomPricedItems(cart) {
    return cart.items.some(function(item) {
      return item.properties && item.properties['_custom_price'] &&
        parseInt(item.properties['_custom_price'], 10) > 0;
    });
  }

  function buildWorkerPayload(cart) {
    return {
      items: cart.items.map(function(item) {
        var customPrice = 0;
        if (item.properties && item.properties['_custom_price']) {
          customPrice = parseInt(item.properties['_custom_price'], 10);
        }
        var title = item.product_title;
        if (customPrice > 0 && item.properties) {
          var w = item.properties['Custom Width'] || '';
          var h = item.properties['Custom Height'] || '';
          var mat = item.properties['Material Type'] || '';
          if (mat) mat = mat.charAt(0).toUpperCase() + mat.slice(1);
          title = item.product_title + ' - ' + mat + ' - ' + w + ' x ' + h;
        } else if (item.variant_title) {
          title = item.product_title + ' - ' + item.variant_title;
        }
        return {
          variant_id: item.variant_id,
          product_id: item.product_id,
          quantity: item.quantity,
          custom_price: customPrice > 0 ? customPrice : 0,
          title: title,
          properties: item.properties || {}
        };
      }),
      note: cart.note || ''
    };
  }

  function interceptCheckout(e) {
    var button = e.target.closest('[name="checkout"], .cart__checkout');
    if (!button) return;

    // Fetch current cart to check for custom prices
    e.preventDefault();
    e.stopPropagation();

    // Disable button and show loading state
    button.disabled = true;
    var originalText = button.textContent;
    button.textContent = 'Processing...';

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      if (!hasCustomPricedItems(cart)) {
        // No custom prices — proceed with normal Shopify checkout
        button.disabled = false;
        button.textContent = originalText;
        window.location.href = '/checkout';
        return;
      }

      // Has custom prices — create draft order
      var payload = buildWorkerPayload(cart);

      return fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data.checkout_url) {
          window.location.href = data.checkout_url;
        } else {
          alert('Something went wrong creating your order. Please try again or contact us.');
          button.disabled = false;
          button.textContent = originalText;
        }
      });
    })
    .catch(function(err) {
      alert('Something went wrong. Please try again or contact us.');
      button.disabled = false;
      button.textContent = originalText;
    });
  }

  // Listen for clicks on checkout buttons (cart drawer + cart page)
  document.addEventListener('click', interceptCheckout, true);
})();
